export default __webpack_public_path__ + "static/media/laser-hair-removalp.94cd70d8.pdf";